
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/context-module-progressions/jst/ProgressionsIndex';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  
  return "\n      <ul class=\"collectionViewItems\"></ul>\n    ";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.atLeastOnePageFetched), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("modules.progressions_index")
  },data:data},helper ? helper.call(depth0, "no_students_found", "No students were found", options) : helperMissing.call(depth0, "t", "no_students_found", "No students were found", options)))
    + "</p>\n      ";
  return buffer;
  }

  buffer += "<h1 class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("modules.progressions_index")
  },data:data},helper ? helper.call(depth0, "progression_header", "Module Progression", options) : helperMissing.call(depth0, "t", "progression_header", "Module Progression", options)))
    + "</h1>\n<div class=\"module-progress-view\">\n  <div\n    class=\"module-progress-view__modules\"\n    id=\"progression_modules\"\n    aria-busy=\"true\"\n    aria-live=\"polite\"\n    aria-relevant=\"additions\"\n    aria-atomic=\"false\"\n  >\n  </div>\n  <div\n    class=\"module-progress-view__students\"\n    id=\"progression_students\"\n    aria-busy=\"true\"\n  >\n    <div class=\"header\">\n      <h3>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("modules.progressions_index")
  },data:data},helper ? helper.call(depth0, "student_progress", "Student Progress", options) : helperMissing.call(depth0, "t", "student_progress", "Student Progress", options)))
    + "</h3>\n      <a title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("modules.progressions_index")
  },data:data},helper ? helper.call(depth0, "back_to_modules", "Back to Modules Page", options) : helperMissing.call(depth0, "t", "back_to_modules", "Back to Modules Page", options)))
    + "\" href=\"";
  if (helper = helpers.modules_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.modules_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n        <i class=\"icon-x standalone-icon\"></i>\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("modules.progressions_index")
  },data:data},helper ? helper.call(depth0, "back_to_modules", "Back to Modules Page", options) : helperMissing.call(depth0, "t", "back_to_modules", "Back to Modules Page", options)))
    + "</span>\n      </a>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  